import { STORAGE_KEYS } from 'src/constants/constants';
import { loadFromLocalStorage, saveToLocalStorage } from 'src/libs/utils';

// Re-export types so existing consumers don't break
export type { FeedbackPayload, FeedbackHistoryItem } from './models/feedback';

// ────────────────────────────────────────
// Device ID
// ────────────────────────────────────────

/**
 * Get or generate a persistent device ID stored in localStorage.
 * Format: `rhc_<timestamp>_<random>` – unique per browser/device.
 */
export const getDeviceId = (): string => {
  let deviceId = loadFromLocalStorage(STORAGE_KEYS.DEVICE_ID);
  if (!deviceId) {
    deviceId = `rhc_${Date.now()}_${Math.random().toString(36).substring(2, 10)}`;
    saveToLocalStorage(STORAGE_KEYS.DEVICE_ID, deviceId);
  }
  return deviceId;
};
